import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FactoringOperationDTO, InvoiceBuyOrderMinuteDTO } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-detail';

@Component({
  selector: 'app-operation-list',
  templateUrl: './operation-list.component.html',
  styleUrls: ['./operation-list.component.scss']
})
export class OperationListComponent {
  public order: any;
  public menu!: CdkContextMenuTrigger;
  @Input() operations: Array<FactoringOperationDTO>;
  @Input() forMinute: boolean = false;
  @Output() invoiceOperationToUpdate = new EventEmitter<FactoringOperationDTO>;
  @Output() invoiceOperationToRemove = new EventEmitter<bigint>;
  @ViewChild(MatSort, { static: true})
  sort: MatSort = Object.create(null);
  public ordenes: InvoiceBuyOrderMinuteDTO;

  public dataSource!: MatTableDataSource<FactoringOperationDTO>;
  public dataSourceOrder!: MatTableDataSource<InvoiceBuyOrderMinuteDTO>;
  public displayedCols = [
    'folio',
    'debtorName',
    'invoiceTotalAmount',
    'financedAmount',
    'plazo',
    'rate',
    'allInRate',
    'comment'
  ];
  public displayedColsOrder = [
    'amount',
    'code',
    'fechaEmision',
    'plazo',
    'sigfe'
  ];
  
  constructor() {
    this.dataSource = new MatTableDataSource<FactoringOperationDTO>([]);
    this.dataSourceOrder = new MatTableDataSource<InvoiceBuyOrderMinuteDTO>([]);
  }
  
  ngOnInit(): void {
    if(!this.forMinute){
      this.displayedCols.push('operationState');
    }
    this.dataSource = new MatTableDataSource<FactoringOperationDTO>([]);
    this.dataSource.sort = this.sort;
    this.dataSourceOrder = new MatTableDataSource<InvoiceBuyOrderMinuteDTO>([]);
    this.dataSourceOrder.sort = this.sort;
    this.setDataSource(this.operations);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['operations'] && changes['operations'].currentValue) {
      this.dataSource.data = changes['operations'].currentValue;
      this.dataSource.sort = this.sort;
      if(this.dataSource.data['buyOrder'] != null) {
        for(let operacion of this.dataSource.data)
          {
            this.dataSourceOrder.data.push(operacion.buyOrder);
          }
          this.dataSourceOrder.sort = this.sort;
      }
    }
  }

  private setDataSource(operations: Array<FactoringOperationDTO>) {
    this.dataSource.data = operations;
    this.dataSource.sort = this.sort;
    const buyOrders = operations?.filter(o => o.buyOrder !=null || o.buyOrder !=undefined ).map(o => o.buyOrder);
    this.dataSourceOrder.data = buyOrders;
    this.dataSourceOrder.sort = this.sort;
  }

  public selectOperationToUpdate(operation: FactoringOperationDTO) {
    this.invoiceOperationToUpdate.emit(operation);
  }

  public selectOperationToRemove(operation: FactoringOperationDTO) {
    this.invoiceOperationToRemove.emit(operation.invoiceOperationId);
  }

}
